import React from 'react';
export function Nav() {
  return <nav className="sticky top-0 z-[100] bg-cream/90 backdrop-blur-md border-b border-border py-3.5" data-id="element-266">
      <div className="container-wide flex justify-between items-center" data-id="element-267">
        <div className="font-serif text-lg font-semibold text-ink" data-id="element-268">
          El Origen{' '}
          <em className="font-normal text-gold-dark" data-id="element-269">de tus bloqueos</em>
        </div>
        
      </div>
    </nav>;
}